/**
 * Circle Loader
 * Pure css spinning circle style loader
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

const CircleLoader: React.FC<{
  children?: React.ReactNode;
  loading: boolean;
  primaryColor?: string;
  size?: string;
}> = ({
  children = null,
  loading = true,
  primaryColor = 'primary.main',
  size = '28px',
}) => {
  if (!loading) {
    return children as React.ReactElement;
  }

  return (
    <Icon
      color={primaryColor}
      name="spinner-third"
      spin
      style={{ fontSize: size, marginLeft: 10 }}
    />
  );
};

export default CircleLoader;
